export const Money = {
  format: function (number) {
    let format = { currency: "USD", style: "currency" };

    return Money.parse(number, format);
  },
  parse: function (number, format, locale) {
    if (!locale) {
      locale = "en-US";
    }
    if (!format) {
      format = {
        currency: "USD",
      };
    }

    return number == null || number === "" ? "$0.00" : new Intl.NumberFormat(locale, format).format(number);
    // return !number ? "" : new Intl.NumberFormat(locale, format).format(number);
  },
  humanize: function (number) {
    if (!number) number = "";
    const language = {
      units: [
        "",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "ten",
        "eleven",
        "twelve",
        "thirteen",
        "fourteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eighteen",
        "nineteen",
      ],
      tens: [
        "",
        "",
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety",
      ],
      scales: [
        "",
        "thousand",
        "million",
        "billion",
        "trillion",
        "quadrillion",
        "quintillion",
        "sextillion",
        "septillion",
        "octillion",
        "nonillion",
        "decillion",
        "undecillion",
        "duodecillion",
        "tredecillion",
        "quatttuor-decillion",
        "quindecillion",
        "sexdecillion",
        "septen-decillion",
        "octodecillion",
        "novemdecillion",
        "vigintillion",
        "centillion",
      ],
      negative: "minus",
      zero: "zero",
      hundred: "hundred",
      and: "and",
    };
    if (parseInt(number) === 0) {
      return language.zero;
    }
    let numberToString = number.toString().replace("-", "");
    let numberLength = numberToString.length;
    let sections = [];
    let words = [];
    let endPoint = 0;
    let integers = 0;
    let hasDecimal = false;
    while (numberLength > 0) {
      endPoint = numberLength;

      sections.push(
        numberToString.slice(
          (numberLength = Math.max(0, numberLength - 3)),
          endPoint
        )
      );
    }

    for (let i = 0; i < sections.length; i++) {
      if (sections[i].indexOf(".") >= 0) {
        hasDecimal = true;

        words.push(sections[i] + "/100");
        words.push(language.and);
      } else {
        integers = sections[i].split("").reverse().map(parseFloat);
        if (integers[1] === 1) {
          integers[0] += 10;
        }

        if (language.scales[hasDecimal ? i - 1 : i]) {
          words.push(language.scales[i]);
        }

        if (language.units[integers[0]]) {
          words.push(language.units[integers[0]]);
        }

        if (language.tens[integers[1]]) {
          words.push(language.tens[integers[1]]);
        }
      }
      if (integers[0] || integers[1]) {
        if (integers[2] || (i === 0 && number > 100)) {
          words.push(language.and);
        }
      }

      if (language.units[integers[2]]) {
        words.push(language.units[integers[2]] + " " + language.hundred);
      }
    }

    if (number < 0) {
      words.push(language.negative);
    }

    return words.reverse().join(" ");
  },
};
